export function Changes() {
  return (
    <p>
      This policy replaces all previous versions and is correct as of May 2018. We may change this privacy policy from time to time. We reserve the right to change the policy at any time. By continuing to access or use our services after those changes become effective, you agree to be bound by the revised privacy policy.
      <br />
      <br />
      This Privacy Policy has been generated with the help of Privacy Policy Generator of the German Association for Data Protection and Port.im to ensure that we collect and manage your personal data transparently, fairly and securely.
    </p>
  );
}

export default Changes;
